import { Controller } from 'stimulus';

import AllocationOverTimeGraphController from './allocation-over-time-graph-controller';
import ReturnsGraphController from './returns-graph-controller';

export default class extends Controller {
  inputListener: () => void;

  connect() {
    this.connectInputListener();
  }

  disconnect() {
    this.disconnectInputListener();
  }

  connectInputListener() {
    this.inputListener = this.redrawGraphs.bind(this);
    this.tabNavCardTarget!.addEventListener('change', this.inputListener);
  }

  disconnectInputListener() {
    this.tabNavCardTarget!.removeEventListener('change', this.inputListener);
  }

  redrawGraphs() {
    if (this.returnsGraphController) {
      this.returnsGraphController.draw();
    }
    if (this.allocationOverTimeGraphController) {
      this.allocationOverTimeGraphController.draw();
    }
  }

  get tabNavCardTarget() {
    return this.element.querySelector('.sc-TabNavCard');
  }

  get tabNavController() {
    return this.application.getControllerForElementAndIdentifier(this.tabNavCardTarget!, 'tab-nav-card');
  }

  get returnsGraphTarget() {
    return this.element.querySelector('.AllocationReview-returnsProjectionComponent [data-controller="returns-graph"]');
  }

  get returnsGraphController() {
    return this.application.getControllerForElementAndIdentifier(
      this.returnsGraphTarget!,
      'returns-graph'
    ) as ReturnsGraphController;
  }

  get allocationOverTimeGraphTarget() {
    return this.element.querySelector(
      '.AllocationReview-allocationOverTimeComponent [data-controller="allocation-over-time-graph"]'
    );
  }

  get allocationOverTimeGraphController() {
    return this.application.getControllerForElementAndIdentifier(
      this.allocationOverTimeGraphTarget!,
      'allocation-over-time-graph'
    ) as AllocationOverTimeGraphController;
  }
}
